export default {
  "fontElementMap": "_27nkW",
  "elementSpacing": "bmAUV",
  "headerOne": "Ua86E bmAUV",
  "headerTwo": "_4ugOM bmAUV",
  "headerThree": "ZAiSL bmAUV",
  "headerFour": "f9A6M bmAUV",
  "headerFive": "JyvAQ bmAUV",
  "headerSix": "Dm2ni bmAUV",
  "child": "WstHX"
};